﻿import controller from '../../../../Resources/Scripts/_Shared/Controller';
import { paramsToObject } from '../../../../Resources/Scripts/_Shared/history'
import { appendContent, openOverlay } from '../../_Shared/Scripts/MyAimoParkOverlay'
import { prePaidBooking } from '../../MyAimoParkPrepaidBookingPage/Scripts/Endpoints'

function myAimoParkPrePaidBookingPage(context) {
  const htmlElement = document.querySelector('html');
  const overlayContext = document.querySelector("[data-controller=myaimopark-overlay]");
  const endpointSettings = context.dataset.endpointUrl ? { PermitPageUrl: context.dataset.endpointUrl } : {}

  function init() {
    context.addEventListener('click', async function (event) {
      if (event.target.dataset.permitId) {
        event.preventDefault();

        const heading = event.target.dataset.heading;
        const subHeading = event.target.dataset.subHeading;
        const permitId = event.target.dataset.permitId;
        //Open pre paid bookings overlay
        openPermitOverlay(heading, subHeading, permitId);

        const urlParams = new URLSearchParams(window.location.search);
        urlParams.set('permitId', permitId);

        const newUrl = window.location.origin + window.location.pathname + '?' + urlParams.toString();
        history.replaceState(paramsToObject(urlParams), document.title, newUrl);
      }
    });

    //If url contains permiId paramater - show overlay
    const permitIdQuery = new URLSearchParams(window.location.search).get('permitId');

    if (permitIdQuery) {
      const permitListItem = context.querySelector(`.myaimoparkprepaidbooking__list li a[data-permit-id="${permitIdQuery}"]`);

      if (permitListItem) {
        const heading = permitListItem.dataset.heading;
        const subHeading = permitListItem.dataset.subHeading;
        const permitId = permitListItem.dataset.permitId;

        //Open permit overlay
        openPermitOverlay(heading, subHeading, permitId);
      }
    }
  }

  async function openPermitOverlay(heading, subHeading, permitId) {
    openOverlay(overlayContext, { heading, subHeading, clearContent: true });

    const getPrePaidBookingInformation = await prePaidBooking.getPrePaidBookingInformation({ ...endpointSettings, PermitId: permitId }).catch((err) => err);

    if (getPrePaidBookingInformation.status === 200) {
      if(htmlElement.classList.contains('map-overlay-active')) {
        appendContent(overlayContext, null, getPrePaidBookingInformation.body);
      }
    }
    // else {
    //   appendContent(overlayContext, { error: true });
    // }
  }

  return {
    init
  };
}

controller.add('myaimopark-pre-paid-booking-page', myAimoParkPrePaidBookingPage);